import { render, staticRenderFns } from "./Azul.vue?vue&type=template&id=a4ca0506"
import script from "./Azul.vue?vue&type=script&lang=js"
export * from "./Azul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports